import {
  RESOURCE_KIND_MAP,
} from "../../../server/routes/constants";
import { poiTypes } from "../../../server/lib/open-planet/poiTypes";
import resourceTypes from "../../../server/lib/open-planet/resourceTypes";
import ListItemBookable from "../pois/components/listItemBookable";
import ListItem from "../pois/components/listItem";

const listItemTypes = {
  poi: {
    component: ListItem,
    title: "Top things to do",
    showCurrency: false,
    resource: resourceTypes.poi,
    kind: "",
  },
  [poiTypes.sights.name]: {
    component: ListItem,
    title: poiTypes.sights.displayName,
    showCurrency: false,
    kind: poiTypes.sights.name,
    resource: resourceTypes.poi,
  },
  [poiTypes.eating.name]: {
    component: ListItem,
    title: poiTypes.eating.displayName,
    showCurrency: false,
    kind: poiTypes.eating.name,
    resource: resourceTypes.poi,
  },
  [poiTypes.activities.name]: {
    component: ListItemBookable,
    title: poiTypes.activities.displayName,
    showCurrency: false,
    kind: poiTypes.activities.name,
    resource: resourceTypes.partner_activity,
  },
  [poiTypes.shopping.name]: {
    component: ListItem,
    title: poiTypes.shopping.displayName,
    showCurrency: false,
    kind: poiTypes.shopping.name,
    resource: resourceTypes.poi,
  },
  [poiTypes.drinking_nightlife.name]: {
    component: ListItem,
    title: poiTypes.drinking_nightlife.displayName,
    showCurrency: false,
    kind: poiTypes.drinking_nightlife.name,
    resource: resourceTypes.poi,
  },
  [poiTypes.entertainment.name]: {
    component: ListItem,
    title: poiTypes.entertainment.displayName,
    showCurrency: false,
    kind: poiTypes.entertainment.name,
    resource: resourceTypes.poi,
  },
  [resourceTypes.lodging]: {
    component: ListItemBookable,
    title: poiTypes.sleeping.displayName,
    showCurrency: false,
    resource: resourceTypes.lodging,
  },
  tours: {
    component: ListItemBookable,
    title: "Tours",
    showCurrency: false,
    kind: RESOURCE_KIND_MAP.tou,
    resource: resourceTypes.partner_activity,
  },
  [poiTypes.transport.name]: {
    component: ListItem,
    title: poiTypes.transport.displayName,
    showCurrency: false,
    kind: poiTypes.transport.name,
    hide: true,
    resource: resourceTypes.poi,
  },
  [poiTypes.info.name]: {
    component: ListItem,
    title: poiTypes.info.displayName,
    showCurrency: false,
    kind: poiTypes.info.name,
    hide: true,
    resource: resourceTypes.poi,
  },
  articles: {
    component: ListItem,
    title: "Articles",
    showCurrency: false,
    hide: true,
    resource: resourceTypes.articles,
  },
  [poiTypes.festivals_events.name]: {
    component: ListItem,
    title: poiTypes.festivals_events.displayName,
    showCurrency: false,
    hide: true,
    kind: poiTypes.festivals_events.name,
    resource: resourceTypes.poi,
  },
  collections: {
    component: ListItem,
    title: "Collections",
    showCurrency: false,
    hide: false,
    resource: resourceTypes.collections,
  },
};

export default listItemTypes;



// WEBPACK FOOTER //
// ./assets/list/listItemTypes.js